import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';
// import { RmCountPriceList } from './rm-count-pricelist-entity';

@Entity('rm_rates_logs')
export class RmCountPriceListLogsEntity {
  @PrimaryGeneratedColumn('increment', { name: 'effective_rmcountrange_id' })
  effectiveRmcountRangeId: number;

    // @Column('int', {
    //     nullable: true,
    //     // length: 30,
    //     name: 'min_value',
    // })
    // minValue: number;

    // @Column('int', {
    //     nullable: true,
    //     // length: 30,
    //     name: 'max_value',
    // })
    // maxValue: number;

    @Column('decimal', {
        precision: 10, 
        scale: 2,      
        nullable: false,
        name: 'count',
    })
    count: number;

    @Column('decimal', {
        precision: 10, 
        scale: 2,
        nullable: false,
        // length: 30,
        name: 'price',
    })
    price: number;

    @CreateDateColumn({
        name: 'effective_from',
        type: 'datetime',
    })
    effectiveFrom: Date;

    @Column({
        name: 'effective_to_date',
        type: 'datetime',
        nullable: true,
    })
    effectiveToDate: Date;

    @Column('boolean', {
        nullable: false,
        name: 'isActive',
        default: true,
    })
    isActive: boolean | null;

    @Column('varchar', {
        nullable: false,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag',
    })
    versionFlag: number;
    // @Column('int', {
    //     nullable: false,
    //     name: 'product_id',
    // })
    // productId: number;

    @Column('int', {
        nullable: false,
        // length: 30,
        name: 'rm_rates_id',
    })
    rmcountPriceListID: number;
    length: number;
    // @ManyToOne(Id=>RmCountPriceList,e=>e.rmpricelist,{nullable:false})
    //     @JoinColumn({name:'count_range_id'})
    //     rmcountPriceListId:RmCountPriceList


    }
